module.exports = __webpack_public_path__ + "img/ogp.9a2583b.png";